export enum PageHeaderVariant {
	Default = 'DefaultHeader',
	Compact = 'CompactHeader',
}
